<ng-container *transloco="let t">
    <div class="space-y-4">
        <img
            [ngSrc]="'/assets/images/135_2.svg'"
            [width]="382"
            [height]="255"
            alt="share-order"
            class="h-auto w-full max-w-xl my-4"
        />

        <form [formGroup]="form" class="space-y-2 mt-4" (ngSubmit)="onSubmit()">
            <tui-input formControlName="name" required tuiAutoFocus>
                {{ t('name.label') }}
            </tui-input>

            <button
                tuiButton
                type="submit"
                appearance="primary"
                class="w-full"
                size="m"
                [disabled]="form.invalid"
                [showLoader]="loading()"
            >
                {{ t('join_now') }}
            </button>
        </form>
    </div>
</ng-container>
